import { CademyError } from '@shared/domain-shared';
import {
    BookingApplicationCheckoutState,
    BookingCheckoutState,
    DateBookingRequestCheckoutState,
    GroupBookingRequestCheckoutState,
    OrderCheckoutState,
    OriginString,
    RequestCheckoutState,
    UTMs,
} from '@shared/types';

export const initialiseBookingFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs,
    occurrenceId?: string
): Promise<BookingCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/booking`,
        {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
                occurrenceId,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

export const initialiseOrderFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs
): Promise<OrderCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/order`,
        {
            method: 'POST',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

export const initialiseRequestFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs
): Promise<RequestCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/request`,
        {
            method: 'POST',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

export const initialiseDateBookingRequestFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs
): Promise<DateBookingRequestCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/date-booking-request`,
        {
            method: 'POST',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

export const initialiseGroupBookingRequestFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs
): Promise<GroupBookingRequestCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/group-booking-request`,
        {
            method: 'POST',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};

export const initialiseBookingApplicationRequestFlow = async (
    checkoutId: string | null,
    courseId: string,
    origin: OriginString,
    bookedOnURL: string,
    utms: UTMs,
    occurrenceId?: string
): Promise<BookingApplicationCheckoutState> => {
    const response = await fetch(
        `${process.env.NEXT_PUBLIC_CADEMY_API_URL}/checkout/initialise/booking-application`,
        {
            method: 'POST',
            body: JSON.stringify({
                checkoutId,
                courseId,
                origin,
                bookedOnURL,
                utms,
                occurrenceId,
            }),
        }
    );
    if (response.ok === false) {
        if (response.headers.get('content-type') === 'application/problem+json') {
            const problemDetails = await response.json();
            const error = CademyError.fromObject(problemDetails);
            throw error;
        }
        const error = await response.text();
        throw new Error(error);
    }
    return response.json();
};
